import classnames from 'classnames'

import { FloatingTooltip } from '../../Floating'
import { MultiValuedListItem } from '../../MultiValuedList'
import Text from '../../Text'

import * as styles from './TextMultiValuedListItem.module.css'

function TextMultiValuedListItem({
  children,
  className = styles.TextMultiValuedListItem,
  disabled,
  done,
  isSecondary,
  isSingle,
  size,
  unread,
  ...itemProps
}) {
  const textProps = {
    children,
    disabled,
    done,
    isSecondary,
    unread,
  }

  const mods = {
    [styles.single]: isSingle,
    ...(size ? { [styles[size]]: true } : null),
  }

  return children ? (
    <MultiValuedListItem
      {...itemProps}
      className={classnames(className, mods)}
      isSingle={isSingle}
      size={size}
    >
      <FloatingTooltip content={children}>
        <Text {...textProps} className={classnames(styles.text, mods)} />
      </FloatingTooltip>
    </MultiValuedListItem>
  ) : null
}

export default TextMultiValuedListItem
